/* MOOGCO 2026-09-14: sepet cekmecesi dinamik oneri. cart-cross-sell.liquid ile birlikte calisir. */
(function(){
  if (window.customElements && customElements.get('moogco-cart-recs')) return;
  var cache = {};
  function fetchRecs(pid, intent, limit){
    var key = pid + ':' + intent;
    if (!cache[key]) {
      cache[key] = fetch('/recommendations/products?section_id=moogco-cart-recs&product_id=' + pid + '&intent=' + intent + '&limit=' + limit)
        .then(function(r){ return r.ok ? r.text() : ''; })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-rec-id]'));
        })
        .catch(function(){ return []; });
    }
    return cache[key];
  }
  function sliderHtml(slides){
    var wrap = document.createElement('div');
    wrap.innerHTML = '<slideshow-section class="wt-slider wt-slider--cross-sell" data-skip-center-nav-method="true"><div data-swiper class="wt-slider__container" data-sound="off"><div data-swiper-container class="video-reels__container"></div><div class="swiper-button-next wt-slider__nav-btn wt-slider__nav-next wt-slider__nav-next--featured"></div><div class="swiper-button-prev wt-slider__nav-btn wt-slider__nav-prev wt-slider__nav-prev--featured"></div></div><script data-swiper-configuration type="text/json">{"slidesPerView":"auto","spaceBetween":0,"freeMode":false,"speed":150,"grabCursor":true,"centeredSlides":false,"loop":false,"slideToClickedSlide":true,"enableOnMedia":"(min-width: 0px)","pagination":false,"breakpoints":{"400":{"slidesPerView":"auto"}},"navigation":{"nextEl":".wt-slider__nav-next--featured","prevEl":".wt-slider__nav-prev--featured"}}<\/script>';
    var cont = wrap.querySelector('[data-swiper-container]');
    slides.forEach(function(s){ cont.appendChild(s); });
    return wrap.firstChild;
  }
  class MoogcoCartRecs extends HTMLElement {
    connectedCallback(){
      var self = this, pids = [];
      try { pids = JSON.parse(this.dataset.cartPids || '[]'); } catch(e) {}
      if (!pids.length) return;
      var inCart = {}; pids.forEach(function(p){ inCart[String(p)] = true; });
      var seen = {}, out = [];
      function take(list){ list.forEach(function(el){ var id = el.getAttribute('data-rec-id'); if (inCart[id] || seen[id] || out.length >= 8) return; seen[id] = true; out.push(el.cloneNode(true)); }); }
      var firstThree = pids.slice(0, 3);
      Promise.all(firstThree.map(function(p){ return fetchRecs(p, 'complementary', 4); })).then(function(lists){
        lists.forEach(take);
        var mode = out.length ? 'pairs' : 'related';
        if (out.length >= 3) return { mode: mode };
        return fetchRecs(pids[0], 'related', 6).then(function(l){ take(l); return { mode: mode }; });
      }).then(function(res){
        if (!out.length || !self.isConnected) return;
        /* sepet $100 altindaysa ucretsiz kargolu onerileri one al (eklenen urun kargo ucreti getirmesin) */
        var subtotal = parseFloat(self.dataset.cartSubtotal || '0');
        if (subtotal < 100) {
          out = out.map(function(el, i){ return {el: el, i: i, free: el.getAttribute('data-rec-free') === '1'}; })
                   .sort(function(a, b){ return (b.free - a.free) || (a.i - b.i); })
                   .map(function(x){ return x.el; });
        }
        var box = self.querySelector('.wt-cart__cross-sell__products');
        var heading = self.querySelector('.wt-cart__cross-sell__heading');
        if (!box) return;
        var nav = self.querySelector('.wt-cart__cross-sell__nav-icons');
        var nextIcon = self.querySelector('.wt-slider__nav-next--featured'), prevIcon = self.querySelector('.wt-slider__nav-prev--featured');
        var slider = sliderHtml(out);
        if (nextIcon) slider.querySelector('.wt-slider__nav-next--featured').innerHTML = nextIcon.innerHTML;
        if (prevIcon) slider.querySelector('.wt-slider__nav-prev--featured').innerHTML = prevIcon.innerHTML;
        box.innerHTML = '';
        box.appendChild(slider);
        if (!customElements.get('slideshow-section')) { var s = document.createElement('script'); s.type = 'module'; s.src = self.dataset.sliderSrc; document.head.appendChild(s); }
        if (heading && res.mode === 'pairs') {
          var toggle = heading.querySelector('.wt-cart__cross-sell__toggle');
          heading.textContent = self.dataset.headingPairs + ' ';
          if (toggle) heading.appendChild(toggle);
        }
      });
    }
  }
  customElements.define('moogco-cart-recs', MoogcoCartRecs);
})();
